// Import model
import { DataviewProposalResponse } from '../models/DataviewProposalResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterProposalRequest } from '../models/FilterProposalRequest';
import { Proposal } from '../models/Proposal';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterProposalRequestSerializer } from './FilterProposalRequestSerializer';
import { ProposalSerializer } from './ProposalSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewProposalResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewProposalResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewProposalResponse instance
   */
  static deserialize(json: string): DataviewProposalResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewProposalResponse instance
   */
  static fromObject(obj: any): DataviewProposalResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewProposalResponse');
    }


    const instance: DataviewProposalResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        ProposalSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterProposalRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewProposalResponse instances
   */
  static deserializeArray(json: string): DataviewProposalResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewProposalResponse instance to a JSON string
   */
  static serialize(instance: DataviewProposalResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewProposalResponse instance to a plain object
   */
  static toObject(instance: DataviewProposalResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        ProposalSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterProposalRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewProposalResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewProposalResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
